<template>
  <div>
   
    <br />
     <Menu></Menu>
     <div class="grid-responsive">
          <h1 class="title">Parceiros</h1>
 
          <Parceiro ref="Parceiro" v-on:parceiros="parceiros"  />
          <br />      <br />          
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Nome/Razão social</th> 
                  <th>CPF/CNPJ</th>                  
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td>{{item.idParceiro}}</td>
                  <td>{{item.nomeParceiro}}</td>
                  <td>{{item.cpfCnpj}}</td>                   
                  <td class="text-right td-responsive">
                     <button type="button" class="btn btn-outline-primary" @click="tokenParceiro(item.idParceiro)" style="margin-right:10px;">
                          <i class="fas fa-location-arrow"></i> 
                      </button> 
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
    </div>
   
</template>

<style scoped>
tfoot {
  background-color: #fff;
}
#buttonActions {
  margin-top: 30px;
}
</style>

<script>

import moment from 'moment'

import Menu from "@/components/MenuAdmin.vue";
import Parceiro from './Parceiro'

import {AdminService} from "@/http"

import {FormatCnpjCpf} from '@/utils'


export default {
  name: "parceirosAdmin",
  components: {
    Menu,  
    Parceiro
  },
  data: () => {
    return {
      items:[],  
      showModal: false,  
    };
  },
  methods: {
    visualizar(){
        window.console.log("aqui")
    },
    visualizarParceiro(idParceiro) {
          
        this.$refs["Parceiro"].visualizarParceiro(idParceiro)

    },
    parceiros(){

      AdminService.Parceiros().then(response=>{

         this.items = response.data.map(item =>{

              item.dataCriacao = moment(item.dataCriacao).utc().locale("pt-br").format("LLL")
              item.cpfCnpj    = FormatCnpjCpf(item.cpfCnpj)
              return item
            })      

      }).catch(error=>{
          window.console.log(error)
      })

    }, 
    tokenParceiro(idParceiro){

       AdminService.TokenParceiro(idParceiro).then(response=>{

          const {token}= response.data
          this.$router.push({name:"promocoesParceiro", query: { token }});
          


      }).catch(error=>{
          window.console.error(error.response)
      })

    }
     
  },
  created() {
    this.parceiros()
   
  }, 
  watch:{
    //searchServicos: _.debounce(function(text) { this.handlerServicos(text) }, 500),  
  }
};
</script>
 
